document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector(".milestone-scroll");

    if (!section) return;

    const progress = section.querySelector(".milestone-progress");

    const progressFill = section.querySelector(".milestone-progress__fill");

    const milestones = [
        ...section.querySelectorAll(".milestone-item")
    ];

    /* ==========================================
       PREMIUM CONFETTI ENGINE
    ========================================== */

    class PremiumConfetti {

        constructor() {

            this.canvas = document.createElement("canvas");

            this.ctx = this.canvas.getContext("2d");

            this.canvas.className = "premium-confetti";

            Object.assign(this.canvas.style, {

                position: "fixed",

                inset: "0",

                width: "100%",

                height: "100%",

                pointerEvents: "none",

                zIndex: "999999"

            });

            document.body.appendChild(this.canvas);

            this.resize();

            window.addEventListener(
                "resize",
                () => this.resize()
            );

            this.particles = [];

            this.running = false;

            this.colors = [

                "#FFD43B",

                "#FF922B",

                "#FF4D6D",

                "#339AF0",

                "#845EF7",

                "#51CF66",

                "#00D2FF",

                "#FF66C4"

            ];

            this.shapes = [

                "rect",

                "circle"

            ];

        }

        resize() {

            this.canvas.width = window.innerWidth;

            this.canvas.height = window.innerHeight;

        }

        random(min, max) {

            return Math.random() * (max - min) + min;

        }

        createParticle(x, y) {

            return {

                x,

                y,

                vx: 0,

                vy: 0,

                size: this.random(5, 10),

                rotation: this.random(0, 360),

                rotationSpeed: this.random(-10, 10),

                gravity: 0.18,

                drag: 0.985,

                alpha: 1,

                life: this.random(80, 120),

                color:

                    this.colors[
                        Math.floor(
                            Math.random() *
                            this.colors.length
                        )
                    ],

                shape:

                    this.shapes[
                        Math.floor(
                            Math.random() *
                            this.shapes.length
                        )
                    ]

            };

        }

        burst(x, y, amount = 120) {

            for (let i = 0; i < amount; i++) {

                const particle =
                    this.createParticle(x, y);

                const angle =
                    this.random(
                        0,
                        Math.PI * 2
                    );

                const speed =
                    this.random(
                        4,
                        11
                    );

                particle.vx =
                    Math.cos(angle) * speed;

                particle.vy =
                    Math.sin(angle) * speed;

                this.particles.push(
                    particle
                );

            }

            if (!this.running) {

                this.running = true;

                requestAnimationFrame(
                    () => this.animate()
                );

            }

        }
                animate() {

            this.ctx.clearRect(
                0,
                0,
                this.canvas.width,
                this.canvas.height
            );

            this.particles.forEach((particle) => {

                particle.vx *= particle.drag;
                particle.vy *= particle.drag;

                particle.vy += particle.gravity;

                particle.x += particle.vx;
                particle.y += particle.vy;

                particle.rotation += particle.rotationSpeed;

                particle.life--;

                particle.alpha = particle.life / 120;

                this.ctx.save();

                this.ctx.translate(
                    particle.x,
                    particle.y
                );

                this.ctx.rotate(
                    particle.rotation * Math.PI / 180
                );

                this.ctx.globalAlpha = particle.alpha;

                this.ctx.fillStyle = particle.color;

                if (particle.shape === "circle") {

                    this.ctx.beginPath();

                    this.ctx.arc(
                        0,
                        0,
                        particle.size / 2,
                        0,
                        Math.PI * 2
                    );

                    this.ctx.fill();

                } else {

                    this.ctx.fillRect(
                        -particle.size / 2,
                        -particle.size / 2,
                        particle.size,
                        particle.size * 0.65
                    );

                }

                this.ctx.restore();

            });

            this.particles =
                this.particles.filter(
                    particle => particle.life > 0
                );

            if (this.particles.length) {

                requestAnimationFrame(
                    () => this.animate()
                );

            } else {

                this.running = false;

            }

        }

    }

    /* ==========================================
       CREATE ENGINE
    ========================================== */

    const confetti = new PremiumConfetti();

    let ticking = false;

    const unlocked = new Set();

    function triggerBurst(circle) {

        const rect =
            circle.getBoundingClientRect();

        const x =
            rect.left +
            rect.width / 2;

        const y =
            rect.top +
            rect.height / 2;

        confetti.burst(
            x,
            y,
            140
        );

    }

        /* ==========================================
       UPDATE PROGRESS
    ========================================== */

    function updateProgress() {

        const sectionRect =
            section.getBoundingClientRect();

        const totalScroll =
            section.offsetHeight -
            window.innerHeight;

        let progressValue =
            (-sectionRect.top) /
            totalScroll;

        progressValue = Math.max(
            0,
            Math.min(1, progressValue)
        );

        progressFill.style.width =
            (progressValue * 100) + "%";

        const progressRect =
            progress.getBoundingClientRect();

        const currentFill =
            progressRect.width *
            progressValue;

        milestones.forEach((item, index) => {

            const circle =
                item.querySelector(
                    ".milestone-item__circle"
                );

            if (!circle) return;

            const circleRect =
                circle.getBoundingClientRect();

            const circleCenter =

                (circleRect.left - progressRect.left)

                +

                (circleRect.width / 2);

            if (currentFill >= circleCenter) {

                item.classList.add("active");

                if (!unlocked.has(index)) {

                    unlocked.add(index);

                    triggerBurst(circle);

                }

            } else {

                item.classList.remove("active");

                unlocked.delete(index);

            }

        });

        ticking = false;

    }

    /* ==========================================
       RAF SCROLL
    ========================================== */

    function handleScroll() {

        if (ticking) return;

        ticking = true;

        requestAnimationFrame(
            updateProgress
        );

    }

        /* ==========================================
       PREMIUM BURST
    ========================================== */

    function premiumBurst(circle) {

        const rect = circle.getBoundingClientRect();

        const x = rect.left + rect.width / 2;

        const y = rect.top + rect.height / 2;

        confetti.burst(x, y, 120);

        setTimeout(() => {

            confetti.burst(
                x - 25,
                y - 10,
                70
            );

        }, 120);

        setTimeout(() => {

            confetti.burst(
                x + 25,
                y - 10,
                70
            );

        }, 220);

    }

    /* ==========================================
       REPLACE NORMAL BURST
    ========================================== */

    triggerBurst = function(circle){

        premiumBurst(circle);

    };

    /* ==========================================
       EVENTS
    ========================================== */

    updateProgress();

    window.addEventListener(
        "scroll",
        handleScroll,
        {
            passive:true
        }
    );

    window.addEventListener(
        "resize",
        () => {

            updateProgress();

        }
    );

    /* ==========================================
       VISIBILITY
    ========================================== */

    document.addEventListener(
        "visibilitychange",
        () => {

            if(document.hidden){

                ticking=false;

            }

        }
    );

});